import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import KolmoApplication from '../KolmoApplication.js';
import DataViewer from './DataViewer';

class ViewButton extends Component {

    constructor(props) 
    {
        super(props)

        this.state = {
            textAreaID: props.textAreaID,
            manifestDataHolderID: props.manifestDataHolderID,
            viewerIsShown: false,
            showData: false,
            
            
        }

        this.actionClick = this.actionClick.bind(this)
    }
    
    

    actionClick(event)
    {
        ReactDOM.unmountComponentAtNode(document.getElementById(this.state.manifestDataHolderID));

        let btn_caption = event.target.innerHTML;

        event.target.innerHTML = "evaluating...";

        this.setState({ viewerIsShown : !this.state.viewerIsShown}); 
       
        
        let application = new KolmoApplication(process.env.REACT_APP_DEDICATED_SERVER_ADDRESS, false);

        let data_to_view = { MIME:"", data:"" };

        let manifest = null;

        try
        {
            let manifestText = document.getElementById(this.state.textAreaID).value
            
            manifest = new global.Manifest(JSON.parse(manifestText))
        }
        catch(error)
        {
            data_to_view.MIME = "text"
            data_to_view.data = new Uint8Array(Buffer.from(""+error))
        }

        if (null == manifest)
        {
            ReactDOM.render(<DataViewer viewerIsShown={this.state.viewerIsShown} showData={this.state.showData} data={data_to_view}/>, document.getElementById(this.state.manifestDataHolderID));

            event.target.innerHTML = btn_caption;

            return;
        }

        manifest.target = event.target
        manifest.btn_caption = btn_caption

        application.engine.eval_manifest(manifest).then(data =>{
        
            manifest.target.innerHTML = manifest.btn_caption

            if (data.data.MIME)
                data_to_view.MIME = data.data.MIME
            else
                data_to_view.MIME = "text"

            data_to_view.data = data.data

            ReactDOM.render( <DataViewer viewerIsShown={this.state.viewerIsShown} showData={this.state.showData} data={data_to_view}/>, document.getElementById(this.state.manifestDataHolderID));
        })
        
    }

    render() {
        return (
            <button className="btn btn-sm btn-warning m-2 float-center" onClick={this.actionClick}>View Data</button>
        )
    }
}

export default ViewButton;